import { FrequentPassageRequest } from '@legacy-types';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';
import {
  RejectFrequentPassageRequestData,
  rejectFrequentPassageRequest,
} from '@shared/frequent-passage-requests/endpoints/rejectFrequentPassageRequest';

type RejectFrequentPassageRequestButtonFormProps = {
  frequentPassageRequest: FrequentPassageRequest;
  onSave: (data: FrequentPassageRequest) => void;
  onCancel: () => void;
};

export function RejectFrequentPassageRequestButtonForm({
  frequentPassageRequest,
  onSave,
  onCancel,
}: RejectFrequentPassageRequestButtonFormProps) {
  const { form, fields } = useForm<RejectFrequentPassageRequestData>();

  return (
    <Form
      form={form}
      confirmation={{
        title: 'Success',
        description: 'Frequent Passage Request rejected.',
      }}
      action={(data) => rejectFrequentPassageRequest(frequentPassageRequest, data)}
      onSave={onSave}
      onCancel={onCancel}
    >
      <p>
        You're about to reject a <strong>{frequentPassageRequest.frequentPassageStickerType.name}</strong> sticker for{' '}
        <strong>{frequentPassageRequest.crewMember.user?.fullName}</strong>.
      </p>
      <TextField name={fields.remark} label="Remarks" />
    </Form>
  );
}
